import { render, staticRenderFns } from "./Kpi.vue?vue&type=template&id=e3ec8ace&scoped=true"
import script from "./Kpi.vue?vue&type=script&lang=js"
export * from "./Kpi.vue?vue&type=script&lang=js"
import style0 from "./Kpi.vue?vue&type=style&index=0&id=e3ec8ace&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ec8ace",
  null
  
)

export default component.exports